// @ts-strict-ignore
/* eslint-disable camelcase */
import React from 'react'

interface SelectProps {
  name: string
  value: string
  options: Array<object>
  onChange?: Function
  buttonActions?: Record<string, string | number>
  styles?: object
  brand?: 'money' | 'uswitch' | 'confused'
}

const Select = ({
  name,
  value,
  options,
  onChange,
  buttonActions,
  styles = {},
  brand = 'money',
}: SelectProps) => {
  return (
    <select
      className='Select'
      id={name}
      name={name}
      onChange={onChange}
      value={value}
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'calc(100% - 10px) 50%',
        backgroundImage: `url(/fs-core-assets/icons/${brand}/chevron-down.svg?v=13#chevron-down)`,
        ...styles,
      }}
      {...buttonActions}
    >
      {options.map((ele: any, index: number) => {
        return (
          <option key={index} value={ele.value}>
            {ele.text}
          </option>
        )
      })}
    </select>
  )
}

export default Select
